import { IInputElement } from '../../types';

import { InputTextElement } from '../../form-inputs';

type TPhoneNumberInputProps = Pick<
  IInputElement,
  | 'classNameInput'
  | 'constraints'
  | 'editable'
  | 'error'
  | 'label'
  | 'isLabelEnabled'
  | 'name'
  | 'onBlurCallback'
  | 'onChangeCallback'
  | 'onError'
  | 'placeholder'
  | 'required'
  | 'showIsRequired'
  | 'value'
> & {
  countryCode?: string;
};

/**
 * -----------------------------------------------------------------------------
 * This is used to capture the phone number of a person and tries to add
 * constraints that are used to validate the expected format of
 * a valid phone number.
 */
export function PhoneNumberInputField({
  classNameInput,
  constraints = {},
  editable,
  error,
  label,
  isLabelEnabled,
  name,
  onBlurCallback,
  onChangeCallback,
  onError,
  placeholder,
  required,
  showIsRequired,
  value,
  countryCode,
}: TPhoneNumberInputProps) {
  return (
    <InputTextElement
      classNameInput={classNameInput}
      constraints={{
        feedbackLabel: 'The Phone Number',
        maxLength: 12,
        minLength: 7,
        required: true,
        format: 'phone-number',
        type: 'tel',
        ...constraints,
      }}
      editable={editable}
      error={error}
      hasClearButton
      isLabelEnabled={isLabelEnabled}
      label={label}
      name={name}
      onBlurCallback={onBlurCallback}
      onChangeCallback={onChangeCallback}
      onError={onError}
      placeholder={placeholder || 'Phone Number'}
      required={required}
      showIsRequired={showIsRequired}
      type="tel"
      value={value}
      valuePrefix={countryCode}
    />
  );
}
